export default __webpack_public_path__ + "static/media/project_academia_de_lenguas.47aa2db1.png";